import { useEffect, useMemo } from 'preact/hooks';

type Bubble = {
  left: string;
  size: string;
  duration: string;
  delay: string;
  dx: string;
};

function mk(count: number): Bubble[] {
  const out: Bubble[] = [];
  for (let i = 0; i < count; i++) {
    const size = 4 + Math.random() * 10;
    out.push({
      left: `${Math.random() * 100}%`,
      size: `${size}px`,
      duration: `${8 + Math.random() * 10}s`,
      delay: `${-Math.random() * 15}s`,
      dx: `${Math.random() * 40 - 20}px`,
    });
  }
  return out;
}

export function Bubbles({ count = 22 }: { count?: number }) {
  const bubbles = useMemo(() => mk(count), [count]);
  useEffect(() => {
    // no-op; bubbles are pure-CSS animated via inline styles
  }, []);
  return (
    <div class="bubbles" aria-hidden="true">
      {bubbles.map((b, i) => (
        <span
          key={i}
          style={{
            left: b.left,
            width: b.size,
            height: b.size,
            animationDuration: b.duration,
            animationDelay: b.delay,
            // custom property for keyframe horizontal drift
            ['--dx' as any]: b.dx,
          }}
        />
      ))}
    </div>
  );
}
